<span class="timestamp" [innerHTML]="time_string | trustAsHtml"></span>
